import React, { useState, useEffect } from "react";
import './style.scss';
import { Layout, PageHeader, Button, Row, Col, Card } from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import callIcon from "../../assets/images/call.svg";
import CartService from "../../services/CartService";
import { useHistory } from "react-router";
import R2Footer from "../../components/Footer";

const { Content } = Layout;

const Carts = () => {
    const [carts, setCarts] = useState([]);
    const history = useHistory();

    useEffect(() => {
        getCarts();
        // return () => {
        //     cleanup
        // }
    }, [])

    const getCarts = async () => {
        const data = await CartService.getCarts();
        setCarts(data.items);
    }

    return (
        <Layout style={{ padding: '0 24px 24px', background: '#eeeded' }}>
            <Content
                className="site-layout-background"
                style={{
                    padding: '0px 24px',
                    margin: '16px 0px',
                    minHeight: 280,
                    background: '#eeeded'
                }}
            >
                <PageHeader
                    title={`Abandoned Carts`}
                    onBack={() => history.goBack()}
                />
                {carts.map((cart) => <Card
                    key={cart.id}
                    className='order-card'
                    bordered={false}
                    /* onClick={() => history.push(`/order-details/${order.order_num}`)} */
                    bodyStyle={{
                        padding: "0"
                    }}
                    style={{
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                        borderRadius: '10px',
                        marginBottom: '1rem',
                    }}
                >
                    <Row>
                        <Col span={8}>
                            <div style={{ margin: '1rem' }}>
                                <div className="card-type">{!!cart.eta_delivery_order ? 'Delivery' : 'Takeout'}</div>
                            </div>
                            <div style={{ margin: '1rem' }}>
                                <div className="customer-details" style={{ marginTop: '2rem' }}>Customer Details:</div>
                                <div style={{ display: 'flex', alignContent: 'space-between', marginTop: '1rem', marginBottom: '1rem' }}>
                                    <div className="customer-name">{cart.name}</div>
                                    {cart.phone ? <a className='call-button' href={'tel:' + cart.phone}>
                                        <img src={callIcon} alt="check" style={{ margin: '.2rem' }} />Call
                                    </a> : <></>}
                                </div>
                                <div className="address">{cart?.address}</div>
                            </div>
                        </Col>
                        <Col className="line-l" span={cart.order_status === 'ORDER_PLACED' ? 5 : 6}>
                            <div className="mid-card">
                                <div style={{ padding: '1rem 2rem 1rem 2rem' }}>
                                    <div style={{ margin: '2rem', marginBottom: '1rem' }}>
                                        <NotifyButton cart={cart} />
                                    </div>
                                </div>
                                <div className='order-time-font' style={{ display: 'flex', justifyContents: 'space-between', padding: '1rem 1rem 1rem 1rem' }}>
                                    <div style={{ margin: 'auto', marginBottom: '2rem' }}>
                                        <div>Added in cart:</div>
                                        <div className="created_at">
                                            {cart.created_at?.split('T')?.[0]?.split('-')?.reverse()?.join('/')} {new Date(cart.created_at)?.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col className="line-l" span={cart.order_status === 'ORDER_PLACED' ? 11 : 10}>
                            <div style={{ height: '100%', padding: '1rem 2rem 1rem 2rem' }}>
                                <div style={{ width: '100%' }}>
                                    <div className="see-all">See all</div>
                                </div>
                                {cart.cart_items.slice(0, 3).map((item, i) => (
                                    <div key={i} className="order-item">
                                        <div>{item.quantity} {item.menu_item}</div>
                                        <div className="price">$ {item.price.toFixed(2)}</div>
                                    </div>
                                ))}
                                <hr />
                                <div className="card-footer">
                                    <div className="total-bill">Total Bill
                                        {
                                            cart.payment_id ? <div className="paid-pill">Paid</div> : <></>
                                        }
                                    </div>
                                    <div className="total-bill total-price">$ {cart.price}</div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>)}
            </Content>
            <R2Footer />
        </Layout>
    )
}

const NotifyButton = ({ cart }) => {
    const [sendingNotification, setSendingNotification] = useState(false);

    const sendNotification = async (cart_id) => {
        setSendingNotification(true);
        try {
            await CartService.notifyUser(cart_id);
        } catch (e) {
            console.log(e);
        }
        setSendingNotification(false);
    }

    return <Button style={{ backgroundColor: '#C32340', color: '#ffffff', borderRadius: '4px', height: '45px' }} className='accept-call-btn' onClick={() => sendNotification(cart.cart_id)}>
        {sendingNotification ? <LoadingOutlined /> : 'Notify User'}
    </Button>;
}

export default Carts;
